import React from 'react';

import { ImageFit, Image } from 'office-ui-fabric-react/lib/Image';

const previewProperties = {
  imageFit: ImageFit.contain,
  width: 120,
  height: 120,
};

function generatePreviewUrl({ id }) {
  return `https://res.cloudinary.com/auctiontech/image/upload/c_pad,b_white,h_${previewProperties.height},w_${previewProperties.width}/${id}.jpg`;
}

const DocPreview = ({ item }) => {
  var src = generatePreviewUrl(item);
  return <Image src={src} {...previewProperties} />;
};

export default DocPreview;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/DocPreview.jsx